// extracted by mini-css-extract-plugin
export default {"form":"BuyForm_form__8MbGl","label":"BuyForm_label__jLs-9"};